// extracted by mini-css-extract-plugin
export var layout = "layout-module--layout--a-PUq";
export var main = "layout-module--main--5VKR9";